import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CurrentUserService } from './current-user.service';
import {
  ObjectiveProgress,
  ReductionObjective,
  UpsertObjectiveDto,
} from '../model/reduction-objective';

@Injectable({ providedIn: 'root' })
export class ReductionObjectivesService {
  private http = inject(HttpClient);
  private currentUserService = inject(CurrentUserService);

  upsertObjectives(
    companyId: string,
    objectives: UpsertObjectiveDto[]
  ): Observable<ReductionObjective[]> {
    return this.http
      .put<ReductionObjective[]>(
        `${environment.apiUrl}/company/${companyId}/objectives`,
        { objectives }
      )
      .pipe(tap(() => this.currentUserService.refreshCurrentUser()));
  }

  removeObjective(companyId: string, type: string): Observable<void> {
    return this.http
      .delete<void>(`${environment.apiUrl}/company/${companyId}/objectives/${type}`)
      .pipe(tap(() => this.currentUserService.refreshCurrentUser()));
  }

  getProgress(companyId: string): Observable<ObjectiveProgress[]> {
    return this.http.get<ObjectiveProgress[]>(
      `${environment.apiUrl}/company/${companyId}/objectives/progress`
    );
  }
}
